<div class="carte" [routerLink]="['/atelier', atelier.documentId]">
    <span class="banner banner-top" [ngStyle]="{'background': '#' +atelier.type_de_prestation.couleur}"></span>
    <span class="banner banner-bottom" [ngStyle]="{'background': '#' +atelier.type_de_prestation.couleur}"></span>
    <!-- <img [src]="'http://localhost:1337' + atelier.type_de_prestation.couleur" alt=""> -->

    <div class="info">
        <h2>{{ atelier.titre }}</h2>
        <app-themes-wrapper [themes]="atelier.themes" />
        <p class="description">{{atelier.description_courte}}</p>
    </div>


    <div class="secondary-info">
        <div class="crop-thumbnail" [ngStyle]="{'transform': 'rotate(' + randomRotation + 'deg)'}">
            <span class="corner corner-top" ></span>
            <img [src]="getImageUrl(atelier.gallery[0].url)" alt="">
            <span class="corner corner-bottom"></span>
        </div>

        <p class="details">
            plus d'informations
        </p>
    </div>


</div>